class RecipientForm extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.toggle = this.querySelector('[data-toggle]')
    this.hiddenControlField = this.querySelector(
      `#Recipient-control-${this.dataset.sectionId}`,
    )
    this.hiddenControlField.disabled = true
    this.emailInput = this.querySelector(
      `#Recipient-email-${this.dataset.sectionId}`,
    )
    this.nameInput = this.querySelector(
      `#Recipient-name-${this.dataset.sectionId}`,
    )
    this.messageInput = this.querySelector(
      `#Recipient-message-${this.dataset.sectionId}`,
    )
    this.sendonInput = this.querySelector(
      `#Recipient-send-on-${this.dataset.sectionId}`,
    )
    this.offsetProperty = this.querySelector(
      `#Recipient-timezone-offset-${this.dataset.sectionId}`,
    )
    this.recipientCheckbox = this.querySelector(
      `#Recipient-checkbox-${this.dataset.sectionId}`,
    )
    if (this.offsetProperty) {
      this.offsetProperty.value = new Date().getTimezoneOffset()
    }

    this.errorMessageWrapper = this.querySelector('[data-error-box]')
    this.errorMessageList = this.errorMessageWrapper?.querySelector(
      '[data-error-list]',
    )
    this.errorMessage = this.errorMessageWrapper?.querySelector(
      '.gft-GiftCardRecipient_ErrorMessage',
    )
    this.defaultErrorHeader = this.errorMessage?.innerText
    this.currentProductVariantId = this.dataset.productVariantId
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.toggle, 'toggle', this.onChange.bind(this))
  }

  onChange () {
    if (this.toggle.hasAttribute('open')) {
      this.enableRecipientCheckbox()
      this.enableInputFields()
    } else {
      this.clearInputFields()
      this.disableInputFields()
      this.clearErrorMessage()
      this.disableRecipientCheckbox()
    }
  }

  inputFields () {
    return [
      this.emailInput,
      this.nameInput,
      this.messageInput,
      this.sendonInput,
    ]
  }

  disableableFields () {
    return [...this.inputFields(), this.offsetProperty, this.recipientCheckbox]
  }

  clearInputFields () {
    this.inputFields().forEach(field => (field.value = ''))
  }

  enableInputFields () {
    this.disableableFields().forEach(field => (field.disabled = false))
  }

  disableInputFields () {
    this.disableableFields().forEach(field => (field.disabled = true))
  }

  enableRecipientCheckbox () {
    this.recipientCheckbox.value = true
  }

  disableRecipientCheckbox () {
    this.recipientCheckbox.value = false
  }

  displayErrorMessage (title, body) {
    this.clearErrorMessage()
    this.errorMessageWrapper.hidden = false
    if (typeof body === 'object') {
      this.errorMessage.innerText = this.defaultErrorHeader
      return Object.entries(body).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`
        const message = `${value.join(', ')}`
        const errorMessageElement = this.querySelector(`#${errorMessageId}`)
        const errorTextElement = errorMessageElement?.querySelector(
          '.gft-GiftCardRecipient_ErrorMessage',
        )
        if (!errorTextElement) return

        if (this.errorMessageList) {
          this.errorMessageList.appendChild(this.createErrorListItem(message))
        }

        errorTextElement.innerText = `${message}.`
        errorMessageElement.removeAttribute('hidden')

        const inputElement = this[`${key}Input`]
        if (!inputElement) return

        inputElement.setAttribute('aria-invalid', true)
        inputElement.setAttribute('aria-describedby', errorMessageId)
      })
    }

    this.errorMessage.innerText = body
  }

  createErrorListItem (message) {
    const li = document.createElement('li')
    li.innerText = message
    li.className = 'gft-GiftCardRecipient_ErrorMessage'
    return li
  }

  clearErrorMessage () {
    this.errorMessageWrapper.hidden = true

    if (this.errorMessageList) this.errorMessageList.innerHTML = ''

    this.querySelectorAll('.gft-GiftCardRecipient_Error').forEach(field => {
      field.setAttribute('hidden', true)
      const textField = field.querySelector(
        '.gft-GiftCardRecipient_ErrorMessage',
      )
      if (textField) textField.innerText = ''
    })
    ;[
      this.emailInput,
      this.messageInput,
      this.nameInput,
      this.sendonInput,
    ].forEach(inputElement => {
      inputElement.setAttribute('aria-invalid', false)
      inputElement.removeAttribute('aria-describedby')
    })
  }

  resetRecipientForm () {
    if (this.toggle.hasAttribute('open')) {
      this.toggle.removeAttribute('open')
      this.clearInputFields()
      this.clearErrorMessage()
      this.disableRecipientCheckbox()
    }
  }
}

if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm)
}
